var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Button } from 'react-bootstrap';
import { Modal as RSModal } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
var Modal = function (props) {
    var size = props.size, open = props.open, setOpen = props.setOpen, children = props.children, header = props.header, actionButton = props.actionButton, className = props.className;
    var closeButton = props.closeButton || true;
    var rsOverflow = props.overflow !== false;
    var handleClose = function () {
        setOpen(false);
    };
    return (_jsx(_Fragment, { children: _jsxs(RSModal, __assign({ overflow: rsOverflow, open: open, onClose: handleClose, 
            /* @ts-ignore */
            size: size, className: className }, { children: [_jsx(RSModal.Header, __assign({ closeButton: false }, { children: header })), _jsx(RSModal.Body, { children: children }), _jsxs(RSModal.Footer, { children: [closeButton &&
                            _jsx(Button, __assign({ variant: "danger", onClick: handleClose }, { children: _jsx(FontAwesomeIcon, { icon: faXmark, size: "sm" }) })), actionButton &&
                            _jsx("span", __assign({ style: { margin: "6px" } }, { children: actionButton }))] })] })) }));
};
export default Modal;
